import { render, staticRenderFns } from "./InvoicesFilters.yaml?vue&type=template&id=85df9bd4&component"
import script from "./InvoicesFilters.yaml?vue&type=script&lang=ts&component"
export * from "./InvoicesFilters.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports